<his-dialog-header
  [showResetButton]="false"
  [showSaveButton]="false"
  [showBackButton]="showBackButton"
  [showSearchButton]="showSearchButton"
  [showCustomButton]="showEditButton && hasEditRights" [customButtonLabel]="'common.edit'"
  (customEvent)="edit()">
  <ng-container customButtons>
    @if (comingFromSearchResult) {
      <button class="backButtonResponsive" (click)="backToPersonSearchResult()"><span>{{'common.backToSearchResult' | hisUi}}</span></button>
    }
    @if (isPersonCompletNameLoaded()) {
      <his-display-webshare [btnTitle]="'cs.sys.webshare.person'" [title]="getFullPersonNameAndTitle()"
        [text]="getFullPersonNameAndTitle()" [url]="getUrl()">
      </his-display-webshare>
    }
  </ng-container>
</his-dialog-header>

@if (!isEmpty(person)) {
  <div class="layoutBlock detailpage">
    <div class="detailpageSideLeft">
      <div class="circleIconContainer">
        <div class="circle-icon">
          <div><img hisImage="user" class="inlineicon" [title]="'psv.Person' | hisUi"></div>
        </div>
      </div>
    </div>
    <div class="detailpageCenter tabMenueDetailpage">
      <psv-person-detail-view-vcard [person]="person"></psv-person-detail-view-vcard>
      <div class="details">
        <div class="detailPresentationList">
          @if (showAboutMe || showResearchFields || showTeachingFields) {
            <psv-collapsible-block-view
              [headers]="blockViewHeader"
              [hisObjects]="blockViewObjects"
              [hisAttribute] ="'entrytext'"
              expandToolTip="fs.res.finance.project.view.showFullLongtext"
              collapseToolTip="fs.res.finance.project.view.showShortLongtext">
            </psv-collapsible-block-view>
          }
          @if (showAboutMe || showResearchFields || showTeachingFields) {
            <div class="detailPresentationListItemBorder"></div>
          }
          @if (!isEmpty(person.extendedData) &&
            !isEmpty(person.extendedData['subjectAreas']) &&
            person.extendedData['subjectAreas'].length > 0) {
            <div
              class="layoutBlock detailPresentationListItem">
              <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.SubjectAreaValue' | hisUi}}</span></div>
              <div class="columnDetailContent detailPresentationListContent">
                @for (subjectArea of person.extendedData['subjectAreas']; track subjectArea) {
                  <span>
                    <a [routerLink]="['/person/searchresult']"
                      [queryParams]="getSubjectAreaQueryParams(subjectArea)"
                      hisImage="tag_orange" class="singleLine transparent"
                      title="{{ 'fs.res.common.subjectArea' | hisUi }}: {{ subjectArea.text }}"
                    (click)="onBeforeNavigate()">{{subjectArea.text}}</a>
                  </span>
                }
              </div>
            </div>
          }
          @if (!isEmpty(person.extendedData) &&
            !isEmpty(person.extendedData['researchAreasKdsf']) &&
            person.extendedData['researchAreasKdsf'].length > 0) {
            <div
              class="layoutBlock detailPresentationListItem">
              <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaKdsfValue' | hisUi}}</span></div>
              <div class="columnDetailContent detailPresentationListContent">
                @for (researchAreaKdsf of person.extendedData['researchAreasKdsf']; track researchAreaKdsf) {
                  <span>
                    @if (researchAreaKdsf) {
                      <a
                        [routerLink]="['/person/searchresult']"
                        [queryParams]="getResearchAreaQueryParams(researchAreaKdsf, true)"
                        hisImage="tag_orange" class="singleLine transparent"
                        title="{{ 'fs.res.common.researchAreasKdsf' | hisUi }}: {{ researchAreaKdsf.text }}"
                      (click)="onBeforeNavigate()">{{researchAreaKdsf.text}}</a>
                    }
                  </span>
                }
              </div>
            </div>
          }
          @if (!isEmpty(person.extendedData) &&
            !isEmpty(person.extendedData['researchAreas']) &&
            person.extendedData['researchAreas'].length > 0) {
            <div
              class="layoutBlock detailPresentationListItem">
              <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaValue' | hisUi}}</span></div>
              <div class="columnDetailContent detailPresentationListContent">
                @for (researchArea of person.extendedData['researchAreas']; track researchArea) {
                  <span>
                    <a [routerLink]="['/person/searchresult']"
                      [queryParams]="getResearchAreaQueryParams(researchArea, false)"
                      hisImage="tag_orange" class="singleLine transparent"
                      title="{{ 'fs.res.common.researcharea' | hisUi }}: {{ researchArea.text }}"
                    (click)="onBeforeNavigate()">{{researchArea.text}}</a>
                  </span>
                }
              </div>
            </div>
          }
          @for (attribut of person.personAttributes | keyvalue:originalOrder; track attribut) {
            <div class="layoutBlock detailPresentationListItem">
              <div class="columnDetailLabel detailPresentationListLabel"><span>{{attribut.key}}</span></div>
              <div class="columnDetailContent detailPresentationListContent"><span>{{attribut.value}}</span></div>
            </div>
          }
        </div>
      </div>
      @if (items?.length >= 1) {
        <p-tabView (click)="onBeforeSetActiveItem()" [(activeIndex)]="activeTabIndex">
          @for (item of items; track item; let i = $index) {
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span hisImage="{{item.icon}}" class="inlineicon tabMenuLinkIcon"></span>
                <div class="tabMenuLinkText">{{'cs.psv.person.detailview.tab.' + item.id | hisUi}}</div>
              </ng-template>
            </p-tabPanel>
          }
        </p-tabView>
      }
    </div>
    <div class="detailpageSideRight">
      <!--Platzhalter für leere rechte Spalte-->
    </div>
  </div>
}

@if (activeMenuItem?.tabIndex === 0 && items?.length > 1) {
  @if (!isEmpty(person.extendedData) && !isEmpty(person.extendedData['listViews'])) {
    <his-listview (btnMoreClicked)="setMenuItemById($event)" [customClickHandler]="true" [listviewKeys]="person.extendedData['listViews']" [listviewData]="person.extendedData"></his-listview>
  }
}

@if (search) {
  @for (item of items; track item) {
    @if (item.tabIndex === activeMenuItem?.tabIndex) {
      <psv-person-detail-view-search-result [entityId]="activeMenuItem.id" [person]="person" [search]="search"></psv-person-detail-view-search-result>
    }
  }
}
